var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 126,
    viewBox: "0 0 114 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9079 100.408L17.8432 99.3617C16.7784 98.3156 15.1052 98.3156 14.1926 99.3617L13.1279 100.408C12.0631 101.454 12.0631 103.098 13.1279 104.144L14.1926 105.19C15.2573 106.236 16.9305 106.236 17.9953 105.19L19.06 104.144C19.9726 103.098 19.9726 101.454 18.9079 100.408Z",
    fill: "#FFB9B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.0865 94.4849L87.1522 87.7119C86.0234 86.583 84.2495 86.583 83.1206 87.7119L76.6702 94.1624C75.5413 95.2912 75.5413 97.0651 76.6702 98.1939L83.6044 105.128C84.7333 106.257 86.5072 106.257 87.636 105.128L94.0865 98.6777C95.2153 97.3876 95.2153 95.6137 94.0865 94.4849Z",
    fill: "#B9E7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0138 81.2849L9.25578 76.5148C8.80971 76.0677 8.06628 75.7695 7.47152 75.7695C6.72808 75.7695 6.13333 76.0677 5.68726 76.5148L0.780538 81.2849C-0.260282 82.3283 -0.260282 83.968 0.780538 85.0114L5.53857 89.7815C6.57939 90.8249 8.21496 90.8249 9.25578 89.7815L14.0138 85.0114C15.0546 84.1171 15.0546 82.3283 14.0138 81.2849Z",
    fill: "#FFD612"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.897 75.5268L106.054 72.8512C104.949 71.8107 103.211 71.8107 102.263 72.8512L99.4204 75.5268C98.9466 75.9727 98.6307 76.7159 98.6307 77.3105C98.6307 78.0537 98.9466 78.6483 99.4204 79.0943L102.263 81.7699C103.369 82.8104 105.107 82.8104 106.212 81.7699L108.897 79.2429C110.003 78.2024 110.003 76.5673 108.897 75.5268Z",
    fill: "#FFB9B9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3282 118.15L57.3225 109.238L51.9655 88.4526L31.2795 94.1021L33.9596 116.774C34.0723 117.727 34.9313 118.398 35.8783 118.273C36.0328 118.253 36.1841 118.211 36.3282 118.15Z",
    fill: "#FFBBA8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0127 109.426L103.692 28.8334L77.8457 13.7944L31.1662 94.3868L57.0127 109.426Z",
    fill: "#FFD300"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1987 109.407L103.714 29.0063L90.846 21.5104L44.3306 101.911L57.1987 109.407Z",
    fill: "#FFE600"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.456 28.5928L105.889 22.6687C108.078 18.8938 106.839 14.0818 103.122 11.9209L92.6535 5.83444C88.9368 3.67351 84.15 4.9819 81.9619 8.75681L78.5279 14.6809L102.456 28.5928Z",
    fill: "#FF769D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.972 32.1599C106.375 29.7375 105.594 26.6575 103.227 25.2804L81.047 12.3735C78.6805 10.9964 75.6248 11.8437 74.2219 14.266C72.819 16.6884 73.6002 19.7684 75.9667 21.1455L98.1467 34.0524C100.513 35.4295 103.569 34.5822 104.972 32.1599Z",
    fill: "#CFCFCF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2628 114.303L32.9083 107.121L34.0479 116.656C34.1623 117.613 35.0261 118.288 35.9774 118.164C36.1326 118.143 36.2846 118.102 36.4293 118.041L45.2628 114.303Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.7568e088430bd955149ed4d8d3605131.svg";
export { ForwardRef as ReactComponent };